module.exports = __webpack_public_path__ + "media/images/childcare/yamina-c56cae5f3a8606282a0a0d69fb2af878.jpg";